/**
 * UI strings, keyed. `en` first; `nl` lands later (AGENTS.md: all strings via
 * keys, no hard-coded copy in components).
 */
export const en = {
  'app.name': 'Noti',
  'app.tagline': 'Docs and databases for your team.',
  'app.loading': 'Loading…',

  'home.title': 'Welcome to Noti',
  'home.signedInAs': 'Signed in as {email}',
  'home.signOut': 'Sign out',
  'home.name.title': 'What should we call you?',
  'home.name.help': 'Your name shows up on everything you write and on who is in the room.',
  'home.name.label': 'Full name',
  'home.name.placeholder': 'Alex Dupont',
  'home.name.submit': 'Continue',
  'home.name.required': 'Please enter your name.',

  'auth.error.no_access':
    'This address does not have access to Noti yet. Ask your workspace administrator for an invitation.',
  'auth.error.sign_in_failed': 'Sign-in could not be completed. Try again.',
  'auth.error.email_unverified': 'That Google address is not verified.',
  'home.next': 'The workspace — page tree, editor and databases — arrives in M2.',

  'workspace.loading': 'Loading your workspace…',
  'workspace.empty': 'You are not in a workspace yet. Ask an owner to invite you.',
  'workspace.selectPage': 'Select a page',
  'workspace.selectPageHint': 'Or create a new page in a workspace.',
  'workspace.newPage': 'New page',
  'workspace.search': 'Search',
  'workspace.trash': 'Trash',
  'workspace.menu': 'Workspace menu',
  'workspace.invite': 'Invite',
  'workspace.signOut': 'Sign out',
  'workspace.pages': 'Pages',
  'workspace.move': 'Move page',
  'workspace.sidebar': 'Workspaces',

  'menu.label': 'Menu',
  'menu.close': 'Close menu',
  'sidebar.home': 'Home',
  'sidebar.searchPages': 'Search pages and text',
  'sidebar.inboxCount': 'Inbox, {count} unread',
  'sidebar.inbox': 'Inbox',
  'sidebar.favorites': 'FAVORITES',
  'sidebar.workspaces': 'WORKSPACES',
  'sidebar.import': 'Import',
  'sidebar.trash': 'Trash',
  'sidebar.settings': 'Settings',
  'sidebar.inviteMembers': 'Invite members',
  'sidebar.onlyYou': 'Only you',
  'sidebar.memberCount': '{count} members',
  'sidebar.newPageIn': 'New page in {workspace}',
  'sidebar.wsOptions': 'Workspace options',
  'sidebar.wsSettings': 'Workspace settings',
  'sidebar.copyLink': 'Copy link',
  'sidebar.newWorkspace': 'New workspace',
  'sidebar.openHome': 'Open workspace home',
  'sidebar.toggleWorkspace': 'Expand or collapse workspace',
  'sidebar.togglePage': 'Expand or collapse page',
  'sidebar.addSubpage': 'Add a subpage',
  'sidebar.pageOptions': 'Page options',
  'sidebar.collapse': 'Collapse sidebar',
  'sidebar.collapseHint': 'Collapse sidebar (⌘\\)',
  'sidebar.expand': 'Open sidebar',
  'sidebar.expandHint': 'Open sidebar (⌘\\)',
  'tab.list': 'Open tabs',
  'tab.new': 'New tab',
  'tab.close': 'Close tab',
  'tab.missing': 'Page not found',
  'topbar.openMenu': 'Open navigation',
  'topbar.closeMenu': 'Close navigation',
  'topbar.back': 'Back',
  'topbar.forward': 'Forward',
  'topbar.breadcrumbs': 'Page path',
  'topbar.share': 'Share',
  'presence.label': 'People on this page',
  'presence.viewingNow': 'Viewing now',
  'presence.lastViewed': 'Last viewed {when}',
  'presence.justNow': 'just now',
  'presence.minuteAgo': '1 minute ago',
  'presence.minutesAgo': '{count} minutes ago',
  'presence.hourAgo': '1 hour ago',
  'presence.hoursAgo': '{count} hours ago',
  'presence.dayAgo': '1 day ago',
  'presence.daysAgo': '{count} days ago',
  'presence.you': '{name} (you)',
  'page.locked': 'Locked',
  'sidebar.account': 'Account menu',

  'page.menu.favorite': 'Add to favorites',
  'page.menu.unfavorite': 'Remove from favorites',
  'page.menu.newTab': 'Open in new tab',
  'page.menu.rename': 'Rename',
  'page.menu.duplicate': 'Duplicate',
  'page.menu.copyLink': 'Copy link',
  'page.menu.trash': 'Move to Trash',
  'page.menu.font': 'Font: {name}',
  'page.font.default': 'Default',
  'page.font.serif': 'Serif',
  'page.font.mono': 'Mono',
  'page.menu.small': 'Small text',
  'page.menu.wide': 'Full width',
  'page.menu.lock': 'Lock page',
  'page.menu.unlock': 'Unlock page',
  'page.menu.lockedHint': 'Unlock the page to edit it',
  'page.menu.import': 'Import Markdown',
  'page.menu.export': 'Export as Markdown',
  'page.menu.undo': 'Undo',
  'page.menu.redo': 'Redo',
  'page.markdown.importTitle': 'Import Markdown',
  'page.markdown.exportTitle': 'Export as Markdown',
  'page.markdown.hint': 'The page body, without the title.',
  'page.markdown.close': 'Close',
  'page.markdown.copy': 'Copy',
  'page.markdown.import': 'Import',

  'share.heading': 'Share {title}',
  'share.tab.share': 'Share',
  'share.tab.publish': 'Publish',
  'share.searchPeople': 'Search people',
  'share.searchPlaceholder': 'Search people or type an email',
  'share.levelLabel': 'Access level',
  'share.level.edit': 'Can edit',
  'share.level.comment': 'Can comment',
  'share.level.view': 'Can view',
  'share.invite': 'Invite',
  'share.invited': '{email} added',
  'share.alreadyHasAccess': 'That address already has access',
  'share.peopleWithAccess': 'People with access',
  'share.accessFor': 'Access for {name}',
  'share.remove': 'Remove {name}',
  'share.inherited': 'Access is inherited from “{page}”. Changes here apply to this page only.',
  'share.generalAccess': 'General access',
  'share.general.invited': 'Only people invited',
  'share.general.workspace': 'Everyone at {workspace}',
  'share.general.web': 'Anyone on the web with link',
  'share.note.invited': 'Only people you invite can open this page.',
  'share.note.workspace': 'Every member of {workspace} can open this page.',
  'share.note.web': 'Anyone with the link can open this page, no sign-in needed.',
  'share.copyLink': 'Copy link',
  'share.manageMembers': 'Manage workspace members',
  'share.done': 'Done',
  'share.loading': 'Loading who has access…',
  'share.publishNotBuilt': 'Publishing to the web is not built yet.',
  'toast.linkCopied': 'Link copied',
  'toast.markdownCopied': 'Markdown copied',
  'toast.wsLinkCopied': 'Workspace link copied',
  'toast.duplicated': 'Page duplicated',
  'toast.later.inbox': 'The inbox arrives in a later milestone.',
  'toast.later.import': 'Import arrives in a later milestone.',
  'toast.later.settings': 'Settings arrive in a later milestone.',
  'toast.later.newWorkspace': 'Creating workspaces arrives in a later milestone.',
  'toast.later.share': 'Sharing arrives in a later milestone.',

  'page.untitled': 'Untitled',
  'page.title': 'Title',
  'page.icon': 'Page icon',
  'page.icon.change': 'Change icon',
  'page.icon.add': 'Add icon',
  'page.icon.choose': 'Choose icon',
  'page.icon.emoji': 'Emoji',
  'page.icon.upload': 'Upload',
  'page.icon.remove': 'Remove',
  'page.icon.search': 'Search emoji…',
  'page.icon.empty': 'No emoji found',
  'page.icon.uploadHint': 'PNG, SVG, JPG or WebP · max 512 KB · square works best',
  'page.cover': 'Cover',
  'page.cover.add': 'Add cover',
  'page.cover.change': 'Change cover',
  'page.cover.choose': 'Choose cover',
  'page.cover.upload': 'Upload an image',
  'page.cover.uploadHint': 'Drop a file here or click. 1500 × 600 px works best.',
  'page.cover.orColor': 'Or choose a color',
  'page.cover.remove': 'Remove cover',
  'page.cover.selection': 'Soft green cover',
  'page.cover.info': 'Blue cover',
  'page.cover.warning': 'Warm cover',
  'page.cover.success': 'Green cover',
  'toast.later.iconUpload': 'Uploading an icon arrives in a later milestone.',
  'toast.later.coverUpload': 'Uploading a cover arrives in a later milestone.',
  'page.trash': 'Move to trash',
  'page.restore': 'Restore',
  'page.saving': 'Saving…',
  'page.saved': 'Saved',
  'page.saveFailed': 'Could not save. Try again.',
  'page.conflict': 'This page was changed somewhere else.',
  'page.reload': 'Reload this page',
  'page.placeholder': "Write, or type '/' for commands",
  'page.open': 'Open {title}',

  'editor.turnInto': 'Turn into',
  'editor.bold': 'Bold',
  'editor.italic': 'Italic',
  'editor.code': 'Code',
  'editor.text': 'Text',
  'editor.h1': 'Heading 1',
  'editor.h2': 'Heading 2',
  'editor.h3': 'Heading 3',
  'editor.h4': 'Heading 4',
  'editor.bullet': 'Bulleted list',
  'editor.numbered': 'Numbered list',
  'editor.todo': 'To-do list',
  'editor.toggle': 'Toggle list',
  'editor.quote': 'Quote',
  'editor.callout': 'Callout',
  'editor.divider': 'Divider',
  'editor.codeBlock': 'Code block',
  'editor.expand': 'Expand',
  'editor.collapse': 'Collapse',
  'editor.underline': 'Underline',
  'editor.strikethrough': 'Strikethrough',
  'editor.link': 'Link',
  'editor.linkApply': 'Apply',
  'editor.linkPlaceholder': 'Paste a link or search pages…',
  'editor.formatting': 'Text formatting',
  'editor.blockOptions': 'Block options',
  'editor.addBelow': 'Add block below',
  'editor.insertBlock': 'Insert block',
  'editor.moveBlocks': 'Move blocks',
  'editor.finishMoving': 'Finish moving',
  'editor.moveBlocksHint': 'Hold a block, then drag it to its new position.',
  'editor.copyText': 'Copy text',
  'editor.cutText': 'Cut text',
  'editor.pasteText': 'Paste text',
  'editor.clipboardChanged':
    'The document changed. Select the text again before cutting or pasting.',
  'editor.clipboardDenied':
    'Chrome did not allow clipboard access. Use the system Copy/Paste menu.',
  'editor.blockActions': 'Block actions',
  'editor.moveOrOptions': 'Drag to move · click for options',
  'editor.duplicate': 'Duplicate',
  'editor.delete': 'Delete',
  'editor.noResults': 'No results',
  'editor.addAtEnd': 'Add block at the end',
  'editor.ph.text': "Type '/' for blocks",
  'editor.text.desc': 'Just start writing with plain text',
  'editor.h1.desc': 'Big section heading',
  'editor.h2.desc': 'Medium section heading',
  'editor.h3.desc': 'Small section heading',
  'editor.h4.desc': 'Smallest heading',
  'editor.bullet.desc': 'Simple list with bullets',
  'editor.numbered.desc': 'List with numbering',
  'editor.todo.desc': 'Track tasks with a checklist',
  'editor.toggle.desc': 'Hide and show content inside',
  'editor.th1': 'Toggle heading 1',
  'editor.th2': 'Toggle heading 2',
  'editor.th3': 'Toggle heading 3',
  'editor.th4': 'Toggle heading 4',
  'editor.th1.desc': 'Collapsible big heading',
  'editor.th2.desc': 'Collapsible medium heading',
  'editor.th3.desc': 'Collapsible small heading',
  'editor.th4.desc': 'Collapsible smallest heading',
  'editor.addLine': '+ Add line',
  'editor.quote.desc': 'Capture a quote',
  'editor.callout.desc': 'Make writing stand out',
  'editor.divider.desc': 'Visually divide blocks',
  'editor.codeBlock.desc': 'Capture a code snippet',
  'editor.database': 'Database',
  'editor.tableOfContents': 'Table of contents',
  'editor.tableOfContents.desc': 'Navigate the headings of this page',
  'editor.tableOfContents.title': 'CONTENTS',
  'editor.tableOfContents.empty': 'Add headings to see a table of contents here.',
  'editor.childPage': 'New page',
  'editor.childPage.desc': 'Create a page below this one and link it',
  'editor.childPage.unnamed': 'Untitled',
  'editor.table': 'Table',
  'editor.table.desc': 'Simple rows and columns',

  'backlinks.title': 'Links to this page',

  'legal.privacy.title': 'Privacy statement',
  'legal.privacy.lead':
    'Noti keeps your notes, your files and your account. This page says what we store, where it is stored and how long we keep it. Noti runs on servers of Hopon in the European Union; your content does not leave the EU.',
  'legal.privacy.who.title': 'Who is responsible',
  'legal.privacy.who.body':
    'Hopon is the controller of the personal data in Noti. You are the controller of the content you put in a workspace you own.',
  'legal.privacy.data.title': 'What we store',
  'legal.privacy.data.account':
    'Your name, your email address and the workspaces you are a member of.',
  'legal.privacy.data.content':
    'The pages, comments and files you put in Noti, together with the versions of every page.',
  'legal.privacy.data.files':
    'The files you upload, with their name, type, size and checksum. The bytes are stored privately and are only served to people who may see the page they hang on.',
  'legal.privacy.data.usage':
    'Technical logs of requests to our servers, with the personal data scrubbed out of them. We keep these for a short time to keep the service running and to find attacks.',
  'legal.privacy.processors.title': 'Processors',
  'legal.privacy.processors.hosting':
    'The server and the database run on our own hosting in the European Union.',
  'legal.privacy.processors.mail':
    'Sign-in links are sent by Resend (United States, European Union processing agreement).',
  'legal.privacy.processors.storage':
    'Uploaded files are stored by Backblaze B2 (United States, European Union region, processing agreement).',
  'legal.privacy.processors.login':
    'Signing in with Google is done by Google (United States, standard contractual clauses).',
  'legal.privacy.processors.dns':
    'Domain names and certificates are handled by Cloudflare (United States, standard contractual clauses).',
  'legal.privacy.retention.title': 'How long we keep it',
  'legal.privacy.retention.sessions':
    'A sign-in session lasts 30 days and is renewed when you keep working.',
  'legal.privacy.retention.magicLinks':
    'A sign-in link is valid for 15 minutes and can be used once.',
  'legal.privacy.retention.logs':
    'Technical logs roll over automatically and are never kept longer than needed. They never contain the content of your pages, your files or your tokens.',
  'legal.privacy.retention.backups':
    'Back-ups of the database are kept for 14 days, encrypted, outside the server.',
  'legal.privacy.retention.trash':
    'Pages in the trash stay there until you empty it or delete them for good.',
  'legal.privacy.rights.title': 'Your rights',
  'legal.privacy.rights.body':
    'You can look at your data, export it as Markdown and CSV, correct it, and ask us to delete it. Every page can be exported from its own menu, and a workspace owner can export a whole workspace. If you want your account and its data removed, ask the workspace owner or write to us; we remove it within 30 days.',
  'legal.privacy.contact.title': 'Questions',
  'legal.privacy.contact.body':
    'Write to privacy@hopon.be. If something goes wrong with your data, we tell the authorities within 72 hours, as the law requires.',

  'legal.terms.title': 'Terms of use',
  'legal.terms.lead':
    'These terms say what you can expect from Noti and what we expect from you. Using Noti means you accept them.',
  'legal.terms.use.title': 'Using Noti',
  'legal.terms.use.body':
    'You need an account. You are responsible for what happens with it, and you must tell us right away if you think someone else has access to it. You may not use Noti for anything unlawful.',
  'legal.terms.content.title': 'Your content',
  'legal.terms.content.body':
    'What you write and upload stays yours. You give us the right to store it and to show it to the people you share it with, because that is what the service does. You are responsible for having the right to share what you upload.',
  'legal.terms.liability.title': 'Liability',
  'legal.terms.liability.body':
    'We do our best to keep Noti running and your data safe, with daily back-ups. But we cannot promise that nothing ever goes wrong, so our liability is limited to what you paid for the service in the twelve months before the problem arose.',
  'legal.terms.contact.title': 'Contact',
  'legal.terms.contact.body': 'Write to hello@hopon.be.',

  'cookies.banner.title': 'Cookies',
  'cookies.banner.body':
    'Noti only uses the cookies that are needed to keep you signed in. We set no tracking cookies and no advertising cookies.',
  'cookies.banner.more': 'Read the privacy statement',
  'cookies.banner.accept': 'Understood',

  'media.image': 'Image',
  'media.image.desc': 'Upload a picture from your computer',
  'media.video': 'Video',
  'media.video.desc': 'Upload a video from your computer',
  'media.audio': 'Audio',
  'media.audio.desc': 'Upload a sound file from your computer',
  'media.pdf': 'PDF',
  'media.pdf.desc': 'Upload a document from your computer',
  'media.file': 'File',
  'media.file.desc': 'Upload any file from your computer',
  'media.untitled': 'Untitled file',
  'media.uploading': 'Uploading…',
  'media.uploadFailed': 'The upload failed.',
  'media.tooLarge': 'That file is too large.',
  'media.wrongType': 'That file type is not allowed.',
  'media.add': 'Add {kind}',
  'media.choose': 'Choose file',
  'media.options': 'File options',
  'media.showLink': 'Show as link',
  'media.showCard': 'Show as card',
  'media.showPreview': 'Show full preview',
  'media.download': 'Download',
  'media.fullscreen': 'Open full screen',
  'media.remove': 'Remove file',
  'media.open': 'Open',
  'media.openFile': 'Open file',
  'media.resize': 'Drag to resize ({width})',
  'media.dblclick': 'Double-click to open',
  'media.viewer': 'File viewer',
  'media.close': 'Close (Esc)',
  'media.prevPage': 'Previous page',
  'media.nextPage': 'Next page',
  'media.zoomIn': 'Zoom in',
  'media.zoomOut': 'Zoom out',
  'media.noPreview': 'No preview available for this file.',
  'media.pageOf': '{page} / {pages}',
  'media.pages': '{count} pages',
  'media.pdfPage': 'Page {page} of {pages}',
  'media.pdfFailed': 'This PDF could not be shown.',
  'table.column': 'Column {number}',
  'table.rowOptions': 'Row {number} options',
  'table.columnOptions': 'Column {number} options',
  'table.insertAbove': 'Insert above',
  'table.insertBelow': 'Insert below',
  'table.insertLeft': 'Insert left',
  'table.insertRight': 'Insert right',
  'table.deleteRow': 'Delete row',
  'table.deleteColumn': 'Delete column',
  'table.addRow': 'Add row',
  'table.addColumn': 'Add column',
  'editor.database.desc': 'Rows with properties, in a table',
  'editor.resizeColumns': 'Drag to resize columns',
  'editor.maxColumns': 'A row can hold up to 4 columns',
  'editor.selectedBlocks': 'Selected blocks',
  'editor.turnSelectedInto': 'Turn selected blocks into',
  'editor.turnIntoCaret': 'Turn into ▾',
  'editor.clear': 'Clear',
  'editor.blockDeleted': 'Block deleted',
  'editor.blocksDeleted': 'Blocks deleted',
  'editor.selCount': '{blocks} · {words}',
  'editor.oneBlock': '1 block',
  'editor.manyBlocks': '{count} blocks',
  'editor.oneWord': '1 word',
  'editor.manyWords': '{count} words',
  'editor.searchActions': 'Search actions…',
  'editor.color': 'Color',
  'editor.textColor': 'Text color',
  'editor.background': 'Background',
  'editor.colorDefault': 'Default',
  'editor.colorGray': 'Gray',
  'editor.colorBrown': 'Brown',
  'editor.colorOrange': 'Orange',
  'editor.colorYellow': 'Yellow',
  'editor.colorGreen': 'Green',
  'editor.colorBlue': 'Blue',
  'editor.colorPurple': 'Purple',
  'editor.colorPink': 'Pink',
  'editor.colorRed': 'Red',
  'editor.selectTextToComment': 'Select text to comment',
  'editor.copyLinkToBlock': 'Copy link to block',
  'editor.linkCopied': 'Link copied',
  'editor.moveTo': 'Move to',
  'editor.chooseTargetPage': 'Choose a target page',
  'editor.moveUp': 'Move up',
  'editor.moveDown': 'Move down',
  'editor.lastEditedBy': 'Last edited by {name}',

  'slash.label': 'Insert a block',
  'slash.group.basic': 'BASIC BLOCKS',
  'slash.group.media': 'MEDIA',

  'mention.label': 'Mention someone',
  'mention.nobody': 'Nobody to mention',

  'invite.title': 'Invite to {workspace}',
  'invite.email': 'Email address',
  'invite.role': 'Role',
  'invite.role.admin': 'Admin',
  'invite.role.member': 'Member',
  'invite.role.guest': 'Guest',
  'invite.send': 'Send invitation',
  'invite.sent': 'Invitation sent to {email}.',
  'invite.close': 'Close',

  'search.title': 'Search',
  'search.placeholder': 'Search a page or text…',
  'search.empty': 'No matches.',
  'search.close': 'Close search',
  'search.openHint': 'Press Enter to open',

  'trash.title': 'Trash',
  'trash.empty': 'Trash is empty.',
  'trash.back': 'Back to pages',
  'trash.searchPlaceholder': 'Search pages in Trash…',
  'trash.sub': 'In Trash',
  'trash.delete': 'Delete',

  'auth.title': 'Sign in to Noti',
  'auth.subtitle': 'We email you a magic link. No password to remember.',
  'auth.email.label': 'Email address',
  'auth.email.placeholder': 'you@example.com',
  'auth.email.required': 'Enter your email address.',
  'auth.email.invalid': 'That does not look like an email address.',
  'auth.submit.email': 'Continue with email',
  'auth.submit.google': 'Continue with Google',
  'auth.divider': 'or',
  'auth.pending.title': 'Check your inbox',
  'auth.pending.body': 'We sent a magic link to {email}. It expires in 15 minutes.',
  'auth.pending.resend': 'Send another link',
  'auth.pending.back': 'Use a different address',

  'editor.comment': 'Comment',
  'comments.thread': 'Comment thread',
  'comments.openThread': 'Open comment thread by {name}',
  'comments.mentionSomeone': 'Mention someone',
  'comments.edited': 'edited',
  'comments.showReply': 'Show {count} reply',
  'comments.showReplies': 'Show {count} replies',
  'comments.resolved': 'Resolved',
  'comments.resolve': 'Resolve',
  'comments.reopen': 'Reopen',
  'comments.moreOptions': 'More options',
  'comments.threadOptions': 'Thread options',
  'comments.copyLink': 'Copy link',
  'comments.deleteThread': 'Delete thread',
  'comments.edit': 'Edit',
  'comments.delete': 'Delete',
  'comments.save': 'Save',
  'comments.cancel': 'Cancel',
  'comments.reply': 'Reply',
  'comments.replyPlaceholder': 'Reply…',
  'comments.send': 'Send',
  'comments.writeComment': 'Write a comment…',
  'comments.post': 'Post',
  'comments.pagePlaceholder': 'Add a comment to this page… (@ to tag)',
  'comments.comment': 'Comment',
  'comments.failed': 'Could not post. Try again.',
  'comments.title': 'Comments',
  'comments.show': 'Show comments',
  'comments.hide': 'Hide comments',
  'comments.displayOptions': 'Comment display options',
  'comments.showResolved': 'Show resolved ({count})',
  'comments.author': 'Author',
  'comments.allAuthors': 'All authors',
  'comments.markLabel': '{count} comments',
  'page.menu.addComment': 'Add comment',

  'theme.label': 'Theme',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.system': 'System',

  'database.loading': 'Loading…',
  'database.unavailable': 'This database is not available.',
  'database.name': 'Database name',
  'database.search': 'Search',
  'database.searchLabel': 'Search database',
  'database.new': 'New',
  'database.newRow': 'New row',
  'database.addView': 'Add view',
  'database.filter': 'Filter',
  'database.filterCount': 'Filter · {count}',
  'database.sort': 'Sort',
  'database.sortCount': 'Sort · {count}',
  'database.group': 'Group',
  'database.groupByName': 'Group: {name}',
  'database.properties': 'Properties',
  'database.view': 'View',
  'database.newView': 'New view',
  'database.close': 'Close',
  'database.laterMilestone': 'That view arrives in a later milestone',
  'database.rowDuplicated': 'Row duplicated',
  'database.rowCleared': 'Row cleared',
  'database.savePropertiesFailed': 'Could not save the properties',
  'database.saveCellFailed': 'Could not save that cell',
  'database.deleteRowFailed': 'Could not delete that row',
  'database.duplicateRowFailed': 'Could not duplicate that row',
  'database.clearRowFailed': 'Could not clear that row',
  'database.addRowFailed': 'Could not add a row',
  'database.renameFailed': 'Could not rename',
  'database.rowColorFailed': 'Could not colour that row',
  'database.needOneView': 'A database needs at least one view',
  'database.savedForYou': 'Saved for you',
  'database.savedForEveryone': 'Saved for everyone',
  'database.viewSettingsFailed': 'Could not save your view settings',
  'database.saveViewFailed': 'Could not save the view',
  'database.backToShared': 'Back to the shared view',
  'database.resetViewFailed': 'Could not reset the view',
  'database.changesDraft': 'Changes to this view are only visible to you.',
  'database.personalSettings': 'You’re using your personal settings for this view.',
  'database.reset': 'Reset',
  'database.saveForMe': 'Save for me',
  'database.saveForEveryone': 'Save for everyone',
  'database.propertyName': 'Property name',
  'database.editOptionsFor': 'Edit options for {name}',
  'database.typeOf': 'Type: {label}',
  'database.hideProperty': 'Hide {name}',
  'database.showProperty': 'Show {name}',
  'database.deleteProperty': 'Delete property',
  'database.optionsComma': 'Options, separated by commas',
  'database.newPropertyPlaceholder': 'New property… press Enter',
  'database.newPropertyName': 'New property name',
  'database.propertyNeedsName': 'Give the property a name',
  'database.type': 'Type',
  'database.columnOptions': 'Column options',
  'database.columnOptionsTitle': 'Click for column options',
  'database.openRow': 'Open row',
  'database.open': 'Open',
  'database.propertyMenu': 'Property',
  'database.sortAscending': 'Sort ascending',
  'database.sortDescending': 'Sort descending',
  'database.filterAction': 'Filter',
  'database.groupAction': 'Group',
  'database.hideInView': 'Hide in view',
  'database.color': 'Color',
  'database.insertLeft': 'Insert left',
  'database.insertRight': 'Insert right',
  'database.clearContents': 'Clear contents',
  'database.duplicateProperty': 'Duplicate property',
  'database.openAsPage': 'Open as page',
  'database.insertAbove': 'Insert above',
  'database.insertBelow': 'Insert below',
  'database.duplicate': 'Duplicate',
  'database.delete': 'Delete',
  'database.searchActions': 'Search actions…',
  'database.searchActionsLabel': 'Search actions',
  'database.dragToResize': 'Drag to resize',
  'database.newPropertyEyebrow': 'NEW PROPERTY',
  'database.add': 'Add',
  'database.calculateFor': 'Calculate {name}',
  'database.propertyCount': '{count} properties',
  'database.newPropertyAdded': 'Property {count}',
  'database.duplicateEditOption': 'Rename or recolor',
  'database.editOption': 'Edit {name}',
  'database.renameOption': 'Option name',
  'database.newOption': 'New option… press Enter',
  'database.deleteOption': 'Delete option',
  'database.createOption': 'Create “{name}”',
  'database.noOptions': 'No options',
  'database.searchOrCreate': 'Search or create new…',
  'database.searchOptions': 'Search options',
  'database.untitled': 'Untitled',
  'database.empty': 'Empty',
  'database.loadFailed': 'Could not load the database properties',
  'database.reloadProperties': 'Reload properties',
  'database.rowUnavailable': 'This database item is no longer available',
  'database.chooseDate': 'Choose date',
  'database.previousMonth': 'Previous month',
  'database.nextMonth': 'Next month',
  'database.today': 'Today',
  'database.clear': 'Clear',
  'database.condition': 'Condition',
  'database.value': 'Value',
  'database.deleteFilter': 'Delete filter',
  'database.matchAny': 'Match: any filter (OR)',
  'database.matchAll': 'Match: all filters (AND)',
  'database.noFilters': 'No filters yet. Add one to narrow down rows.',
  'database.addFilter': '+ Add filter',
  'database.sortBy': 'Sort by',
  'database.ascending': 'Ascending ↑',
  'database.descending': 'Descending ↓',
  'database.removeSort': 'Remove sort',
  'database.noSorts': 'No sorting yet. Add a rule.',
  'database.addSort': '+ Add sort',
  'database.groupBy': 'Group by',
  'database.none': 'None',
  'database.viewName': 'View name',
  'database.layoutTable': 'Table',
  'database.layoutBoard': 'Board',
  'database.layoutCalendar': 'Calendar',
  'database.layoutList': 'List',
  'database.layoutGallery': 'Gallery',
  'database.duplicateView': 'Duplicate view',
  'database.showCalculations': 'Show calculations',
  'database.hideCalculations': 'Hide calculations',
  'database.deleteView': 'Delete view',
  'database.exportCsv': 'Export CSV',
  'database.importCsv': 'Import CSV',
  'database.importCsvLabel': 'Import CSV (columns are matched by name)',
  'database.exportedRows': 'Exported {count} rows',
  'database.importedRows': 'Imported {count} rows',
  'database.noRowsFound': 'No rows found',
  'database.importFailed': 'That file could not be imported',
  'database.newItem': 'New',

  'settings.title': 'Settings',
  'settings.sections': 'Settings sections',
  'settings.close': 'Close settings',
  'settings.name': 'Workspace name',
  'settings.address': 'Address',
  'settings.copyAddress': 'Copy address',
  'settings.tab.general': 'General',
  'settings.tab.connections': 'Connections',
  'settings.tab.tokens': 'Access tokens',
  'settings.tab.mcp': 'MCP',
  'settings.tab.webhooks': 'Webhooks',
  'settings.tab.import': 'Import',
  'settings.sub.general': 'Workspace name, address and who can do what.',
  'settings.sub.connections': 'Connect Noti to the tools you already use.',
  'settings.sub.tokens': 'Give a script or an integration access to this workspace.',
  'settings.sub.mcp': 'Let an assistant read and change your pages.',
  'settings.sub.webhooks': 'Send a call out when something changes here.',
  'settings.sub.import': 'Bring pages and databases in from another tool.',
  'settings.allowGuests': 'Allow guests',
  'settings.allowGuestsSub': 'Guests can be invited to a single page.',
  'settings.membersInvite': 'Members can invite people',
  'settings.membersInviteSub': 'Otherwise only admins can invite.',
  'settings.publish': 'Allow publishing pages to the web',
  'settings.publishSub': 'Anyone with the link can read a published page.',
  'settings.inheritAccess': 'New sub-pages inherit access',
  'settings.inheritAccessSub': 'Sub-pages get the same sharing as their parent.',
  'settings.empty': 'This part of Noti is not built yet.',

  'inbox.title': 'Inbox',
  'inbox.close': 'Close the inbox',
  'inbox.markAllRead': 'Mark all as read',
  'inbox.views': 'Inbox views',
  'inbox.view.all': 'All',
  'inbox.view.unread': 'Unread',
  'inbox.view.archived': 'Archived',
  'inbox.mentionsOnly': 'Mentions only',
  'inbox.viewingAs': 'Viewing as {name}',
  'inbox.empty': 'Nothing waiting for you.',
  'inbox.someone': 'Somebody',
  'inbox.somewhere': 'a page',
  'inbox.yesterday': 'Yesterday',
  'inbox.heading.mention': '{who} mentioned you in {where}',
  'inbox.heading.reply': '{who} replied in a thread on {where}',
  'inbox.heading.assigned': '{who} assigned you on {where}',
  'inbox.heading.access': '{who} requested access to {where}',
  'inbox.archive': 'Archive the item from {name}',

  'tokens.name': 'Token name',
  'tokens.newToken': 'New token',
  'tokens.none': 'No tokens yet.',
  'tokens.revoked': 'Revoked',
  'tokens.revoke': 'Revoke',
  'tokens.revoke.aria': 'Revoke {name}',
  'tokens.expires': 'Expires',
  'tokens.lastUsed': 'Last used',
  'tokens.never': 'never',
  'tokens.scopes': 'Access',
  'tokens.expiresAfter': 'Expires after',
  'tokens.exp1': '1 day',
  'tokens.exp7': '7 days',
  'tokens.exp30': '30 days',
  'tokens.expNever': 'No expiration',
  'tokens.userInfoLabel': 'User info',
  'tokens.userInfo.none': 'No user info',
  'tokens.userInfo.noemail': 'User info without email',
  'tokens.userInfo.email': 'User info with email',
  'tokens.cap.read': 'Read content',
  'tokens.cap.update': 'Update content',
  'tokens.cap.insert': 'Insert content',
  'tokens.cap.rcom': 'Read comments',
  'tokens.cap.icom': 'Insert comments',
  'tokens.revealHead': 'Copy this token now. For safety it is not shown again.',
  'tokens.group.pages': 'Pages',
  'tokens.group.databases': 'Databases',
  'tokens.group.comments': 'Comments',
  'tokens.event.pageCreated': 'Created',
  'tokens.event.pageUpdated': 'Properties updated',
  'tokens.event.pageSaved': 'Content updated',
  'tokens.event.pageDeleted': 'Deleted',
  'tokens.event.dataSourceUpdated': 'Schema updated',
  'tokens.event.rowCreated': 'Row created',
  'tokens.event.rowUpdated': 'Row updated',
  'tokens.event.commentCreated': 'Created',
  'connections.name': 'Connection name',
  'connections.newConnection': 'New connection',
  'connections.hint': 'A connection is the token an AI client uses to reach {url}.',
  'webhooks.name': 'Name',
  'webhooks.url': 'URL',
  'webhooks.add': 'Add webhook',
  'webhooks.remove': 'Remove',
  'webhooks.none': 'No webhooks yet.',
  'webhooks.invalid': 'That webhook needs a name, an https url and at least one event.',
  'mcp.address': 'Address',
  'mcp.copyAddress': 'Copy address',
  'mcp.client.claude': 'Claude Code',
  'mcp.client.cursor': 'Cursor / JSON',
  'mcp.client.stdio': 'Other (stdio)',
  'mcp.bearerHint':
    'Every call carries a token as `Authorization: Bearer hop_…`. Create one under Access tokens or Connections and give it only the capabilities that client needs.',
  'mcp.toolsHint':
    'The tools a client sees follow its capabilities: Read and search, Create and edit pages, Query and update databases, Comments.',

  'error.generic': 'Something went wrong. Try again.',
} as const;

export type MessageKey = keyof typeof en;

export type Messages = Record<MessageKey, string>;
